import React from 'react';

// Sidebar notification marker shared by the CRM and portal sidebars.
// tone "alert" (red) = something is waiting on you (unread messages, open questions);
// tone "new" (emerald) = recent activity worth a look (new leads / clients).
const TONES = {
  alert: {
    pill: 'bg-red-600 text-white',
    dot: 'bg-red-600',
  },
  new: {
    pill: 'bg-emerald-100 text-emerald-700 dark:bg-emerald-900/50 dark:text-emerald-300',
    dot: 'bg-emerald-500',
  },
};

/**
 * Expanded sidebar: a small count pill pushed to the right of the label.
 * Collapsed sidebar: a dot pinned to the icon's top-right corner (place it
 * inside a `relative` icon wrapper).
 */
const SidebarBadge = ({ count, tone = 'alert', title, collapsed = false }) => {
  if (!count || count <= 0) return null;
  const styles = TONES[tone] || TONES.alert;
  const label = count > 99 ? '99+' : String(count);

  if (collapsed) {
    return (
      <span
        className={`absolute -top-0.5 -right-0.5 w-2.5 h-2.5 rounded-full ring-2 ring-white dark:ring-gray-800 ${styles.dot}`}
        title={title}
        aria-label={title}
      />
    );
  }

  return (
    <span
      className={`ml-auto shrink-0 inline-flex items-center justify-center min-w-[1.25rem] h-5 px-1.5 rounded-full text-[11px] font-semibold leading-none tabular-nums transition-transform group-hover:scale-110 ${styles.pill}`}
      title={title}
      aria-label={title}
    >
      {tone === 'new' ? `+${label}` : label}
    </span>
  );
};

/** True when any of the given items carries a badge (for the "See More" row). */
export const hasSidebarBadge = (items) => items.some((item) => item.badge && item.badge.count > 0);

export default SidebarBadge;
